<app-form-input-group [label]="ariaLabel" [isHiddenLabel]="hasAriaLabel">
  <span *ngIf="label" custom-label class="font-bold text-grey-dark-3 text-base">
    {{ label }}
  </span>

  <app-form-autocomplete-v2
    #content
    (click)="preventLabelBehaviour($event)"
    (valueChangeEvent)="suggestionGoogleMaps($event)"
    (clearInputEvent)="clearPlaceInput()"
    (focusInputEvent)="unskipUpdate()"
    (selectItemEvent)="selectPlaceItem($event)"
    [debounceBehavior]="true"
    [placeholder]="placeholder"
    [formControl]="place"
    [items]="suggestions"
    [autoFilter]="false"
    [inputStyle]="inputStyle"
    [iconName]="icon.MapPin"
    [clearButtonAriaLabel]="
      'a11y.attendee.autocomplete.clear_button.label' | translate
    "
  >
    <div #listContent *ngIf="hasGeolocation || hasRadiusSearch">
      <app-form-range-input
        *ngIf="hasRadiusSearch && displayRadiusSearch"
        class="block mb-3 p-3 bg-grey-light-4 -mt-2 -mx-2"
        [label]="
          'attendee.jumbotron.activities.search_input.radius' | translate
        "
        [formControl]="radius"
        [max]="distanceValueCollection?.length - 1"
        [displayValue]="rangeDisplayValue"
      ></app-form-range-input>

      <button
        *ngIf="hasGeolocation"
        class="flex w-full p-2 items-center text-left"
        type="button"
        (click)="geolocalize()"
      >
        <vtmn-play-icon [name]="icon?.Focus"></vtmn-play-icon>
        {{ 'attendee.jumbotron.activities.search_title' | translate }}
      </button>
    </div>

    <div
      *ngIf="hasRadiusSearch && displayRadiusSearch"
      listbox-footer
      class="mb-2"
    >
      <app-divider class="block -mx-2 -my-2"></app-divider>

      <button
        app-vtmn-play-button
        type="button"
        class="ml-auto mr-3"
        (click)="setRadius()"
        data-test="search-button"
      >
        {{ 'attendee.filters.city.button.confirm' | translate }}
      </button>
    </div>
  </app-form-autocomplete-v2>
</app-form-input-group>
